<template>
  <div class="card" @click="openForm">
    <div class="card-header" :style="headerStyles">
      <Unicon
        :name="data.icon_name"
        fill="#fff"
        height="130"
        width="130"
     />
    </div>
    <div class="card-body">
      <span class="tag">
        {{ getTranslatedAchievementType(data.type) }}
      </span>
      <h4 class="body-title">{{ data.name }}</h4>
      <p class="body-description">{{ data.description }}</p>
      <h5 class="body-date">{{ formattedDate }}</h5>
    </div>
  </div>
</template>

<script>
import { useFieldTranslator } from "@/_shared/mixins";
import { formats } from '@/_shared/constants';
export default {
  mixins: [useFieldTranslator],
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    headerStyles() {
      return {
        background: this.data.icon_background,
      };
    },
    formattedDate() {
      if (!this.data.updated_at) {
        return 'Не изменялось';
      }
      const date = new Date(this.data.updated_at);
      const format = formats.dates.achievementCard;
      return date.toLocaleString('ru', format);
    },
  },
  methods: {
    openForm() {
      const slug = `/achievements/${this.data.id}`;
      const routeData = this.$router.resolve(slug);
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style scoped>
.card {
  margin: 10px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  min-height: 250px;
}
.card:hover,
.card:focus {
  opacity: 0.5;
  cursor: pointer;
  transition: 0.3s;
}
.card-header {
  width: 100%;
  min-height: 200px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.card-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 20px;
}

.tag {
  background-color: #08c;
  border-radius: 50px;
  font-size: 12px;
  margin: 0;
  color: #fff;
  padding: 2px 10px;
  text-transform: uppercase;
  cursor: pointer;
}
.body-date {
  color: rgb(129, 128, 128);
  font-size: 0.75em;
}
.body-title,
.body-description {
  word-break: break-all;
}
.body-description {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/user/components/achievements/Card.vue